const COLOR_MAP = [
    '#4f99c1',
    '#002b5f',
    '#ffac17',
    '#4b2514',
    '#de8ba5',
    '#6a035c',
    '#08c3a5',
    '#06423d',
    '#f79668',
    '#712300',
    '#908ec5',
    '#37237b',
    '#a4c032',
    '#2c3b0d'
];

function shuffleArray<T>(array: T[]): T[] {
    const copy = array.slice(0);
    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
}

export default function generateEntityColorMap(annotations: Annotation[]): Record<string, string> {
    const ids = new Set(annotations.map(annotation => annotation.entity_kb_id));
    const shuffledColors = shuffleArray(COLOR_MAP);
    return [...ids].reduce((acc, id, idx) => {
        acc[id] = shuffledColors[idx % shuffledColors.length];
        return acc;
    }, {} as Record<string, string>);
}
